@if (validationsCtrl && validationsCtrl.controls.length > 0) {
  @for (validationCtrl of validationsCtrl.controls; track validationCtrl; let i = $index) {
    <div [formGroup]="validationCtrl">
      @if (showValidationSettings(validationCtrl.get('name')?.value)) {
        <div>
          <mat-form-field appearance="outline" class="w-100 mb-3">
            <mat-label>{{ validationCtrl.get('name')?.value | titlecase }}</mat-label>
            @if (getValidationValueControl(validationCtrl); as safeValueCtrl) {
              <input
                matInput
                [formControl]="safeValueCtrl"
                [placeholder]="validationCtrl.get('name')?.value || '' | titlecase"
                [type]="getValidationValueType(validationCtrl)"
                autocomplete="off"
                />
            }
            @if (validationCtrl.get('name')?.value === 'pattern') {
              <mat-hint>
                Enter an array of regex expressions, e.g. <code>[ /a/, /b/i ]</code>. Single expressions are not
                allowed.
              </mat-hint>
            }
            @if (showPatternFormatError(validationCtrl)) {
              <mat-error>
                Invalid pattern format. Please enter an array of valid regular expressions, e.g.
                <code>[ /a/, /b/i ]</code>.
              </mat-error>
            }
            @if (getValidationError(validationCtrl)) {
              <mat-error>{{
                getValidationError(validationCtrl)
              }}</mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>
  }
}
